(() => {
  const SELECTOR = '[data-kakavy-gallery-counter]';

  const updateCounter = (counter, swiper) => {
    const total = swiper.slides?.length || Number(counter.dataset.total) || 1;
    const activeIndex = Number.isInteger(swiper.realIndex)
      ? swiper.realIndex
      : swiper.activeIndex || 0;
    const current = Math.min(Math.max(activeIndex + 1, 1), total);

    counter.querySelector('[data-kakavy-gallery-current]').textContent = current;
    counter.querySelector('[data-kakavy-gallery-total]').textContent = total;

    const previousButton = counter.querySelector('[data-kakavy-gallery-prev]');
    const nextButton = counter.querySelector('[data-kakavy-gallery-next]');
    const loops = Boolean(swiper.params?.loop);

    previousButton.disabled = !loops && swiper.isBeginning;
    nextButton.disabled = !loops && swiper.isEnd;
  };

  const bindCounter = (counter, slider) => {
    if (counter.dataset.bound === 'true' || !slider.swiper) return;

    const swiper = slider.swiper;
    const previousButton = counter.querySelector('[data-kakavy-gallery-prev]');
    const nextButton = counter.querySelector('[data-kakavy-gallery-next]');

    counter.dataset.bound = 'true';
    previousButton.addEventListener('click', () => swiper.slidePrev());
    nextButton.addEventListener('click', () => swiper.slideNext());
    swiper.on('slideChange', () => updateCounter(counter, swiper));
    swiper.on('slidesLengthChange', () => updateCounter(counter, swiper));
    updateCounter(counter, swiper);
  };

  const waitForSlider = (counter, slider, attempt = 0) => {
    if (!counter.isConnected || !slider.isConnected) return;
    if (slider.swiper) {
      bindCounter(counter, slider);
      return;
    }
    if (attempt < 200) {
      window.setTimeout(() => waitForSlider(counter, slider, attempt + 1), 50);
    }
  };

  const initialize = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach((counter) => {
      if (counter.dataset.bound === 'true') return;
      const slider = document.getElementById(counter.dataset.sliderId);
      if (!slider) return;
      customElements.whenDefined('slide-show').then(() => waitForSlider(counter, slider));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
